import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import BubbleChartOutlinedIcon from "@mui/icons-material/BubbleChartOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import Groups2OutlinedIcon from "@mui/icons-material/Groups2Outlined";
import { Avatar, Box, Button, Card, Typography } from "@mui/material";
import moment from "moment";
import React from "react";
import { useDispatch } from "react-redux";
import UserAvatar from "../../../../components/UserAvatar";
import { cutStrings } from "../../../../shared/cutStrings";
import { getDate } from "../../../../shared/getDate";
import { getTime } from "../../../../shared/getTime";
import { joinEventPostACtion } from "../../../../store/actions/events";

const EventInfoItem = ({ icon, title, color }) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
      <Box
        sx={{
          backgroundColor: "#4B4B4B",
          borderRadius: "50%",
          width: "24px",
          height: "24px",
          p: 0.5,
          mr: 1,
          display: "flex",
          alignItems: "center",
        }}
      >
        {icon}
      </Box>
      <Typography color={color}>{title}</Typography>
    </Box>
  );
};
export default function EventItem({ event }) {
  const dispatch = useDispatch();
  const eventEnded = moment(event?.endDate).isBefore(moment());
  const eventStarted = moment(event?.startDate)
    .startOf("day")
    .isSameOrBefore(moment().startOf("day"));

  const isLive =
    !event?.location &&
    (!eventEnded || (eventEnded && event?.records?.length > 0)) &&
    eventStarted;

  const joinEvent = () => {
    joinEventPostACtion({ eventId: event.id })(dispatch);
  };
  const openLiveEvent = (id) => {};
  // nav(`/community/${pageId}/live-event/${id}?tab=${tabId}`);

  return (
    <Card
      sx={{
        backgroundColor: "#F0F0F0",
        borderRadius: "16px",
        overflow: "hidden",
        boxShadow: "none",
        p: 2,
      }}
    >
      {/* {coverPhoto && (
        <Box
          //   onClick={clicked}
          sx={{
            width: 1,
            height: 103,
            backgroundColor: "text.border",
            cursor: "pointer",
            borderRadius: "6px",
            overflow: "hidden",
          }}
        >
          <img
            loading="lazy"
            src={coverPhoto}
            alt={event?.title}
            style={{
              width: "100%",
              height: "100%",
              display: "inline-block",
              verticalAlign: "middle",
              objectFit: "cover",
            }}
          />
        </Box>
      )} */}
      <Box>
        {!(event?.meetingUrl || isLive) && (
          <Typography variant="caption" color="text.darkSecondary">
            Event ended
          </Typography>
        )}
        <Typography
          component="div"
          variant="h6"
          sx={{
            lineClamp: 1,
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            overflow: "hidden",
            cursor: "pointer",
          }}
          //   onClick={clicked}
        >
          {cutStrings(event?.title, 60)}
        </Typography>

        <Typography
          sx={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: "2",
            WebkitBoxOrient: "vertical",
            color: "text.darkSecondary",
            mb: 2,
          }}
          variant="subtitle2"
        >
          {event?.description}
        </Typography>
        {/* 
        {event?.location && (
          <Box display="flex" sx={{ mb: 2 }}>
            <LocationOnIcon sx={{ color: "text.icon", height: 18 }} />
            <Typography variant="subtitle2">{event?.location}</Typography>
          </Box>
        )} */}

        <EventInfoItem
          icon={
            <CalendarMonthOutlinedIcon sx={{ color: "text.white", width: 1 }} />
          }
          title={getDate(event?.startDate, undefined, "DD MMM YY")}
        />

        <EventInfoItem
          icon={
            <AccessTimeOutlinedIcon sx={{ color: "text.white", width: 1 }} />
          }
          title={getTime(event?.startDate, event?.endDate)}
        />

        <EventInfoItem
          icon={<Groups2OutlinedIcon sx={{ color: "text.white", width: 1 }} />}
          title="Participants:"
          color="text.secondary"
        />
        <Box display="flex" alignItems={"center"} sx={{ mb: 1 }}>
          {event?.users?.map((user) => {
            user = user?.speaker || user?.user || user;
            return (
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <UserAvatar
                  key={user?.id}
                  src={user?.image}
                  type="user"
                  alt={user?.firstname || user?.username}
                  color={user?.color}
                  userId={user?.id}
                  sx={{ width: "24px", height: "24px", mr: 1 }}
                />
                <Typography>{user.firstName}</Typography>
              </Box>
            );
          })}
        </Box>

        <EventInfoItem
          icon={
            <BubbleChartOutlinedIcon sx={{ color: "text.white", width: 1 }} />
          }
          title="Organization:"
          color="text.secondary"
        />

        {event?.eventSponsor.length > 0 && (
          <Box display="flex" sx={{ mb: 2 }}>
            <Typography variant="subtitle2">
              {/* <img src={organizationIcon} alt="" style={{ height: 24 }} /> */}
            </Typography>
            <Typography variant="subtitle2">
              {event?.eventSponsor?.map((organization) => {
                organization = organization?.organization || organization;
                return (
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Avatar
                      src={organization?.image}
                      sx={{ mr: 1, width: "24px", height: "24px" }}
                    />
                    <Typography>{organization?.name}</Typography>
                  </Box>
                );
              })}
            </Typography>
          </Box>
        )}

        <Box sx={{ display: "flex", overflow: "auto", mt: 1 }}>
          {/* {event?.files?.map((file, i) => (
            <FileItem key={i} file={file} downloadFile={downloadFile} />
          ))} */}
        </Box>

        {!event?.status && !event?.meetingUrl && !eventEnded && (
          <Box>
            <Button
              size="small"
              variant="contained"
              color="secondary"
              onClick={joinEvent}
              sx={{ mr: 2 }}
            >
              Interested Remind me
            </Button>
          </Box>
        )}
        {!event?.location &&
          (!eventEnded || (eventEnded && event?.records?.length > 0)) &&
          eventStarted && (
            <Box>
              <Button
                size="small"
                variant="outlined"
                color="secondary"
                onClick={() =>
                  event?.meetingUrl
                    ? window.open(event?.meetingUrl)
                    : openLiveEvent(event?.id)
                }
              >
                {event?.meetingUrl ? "Join session" : "Live Now"}
              </Button>
            </Box>
          )}
      </Box>
    </Card>
  );
}
